import React, { useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import { FiEdit } from 'react-icons/fi';
import { MdDeleteOutline, MdDoNotDisturbOnTotalSilence } from 'react-icons/md';
import { TiPowerOutline } from 'react-icons/ti';
import TmPagination from './Pagination';
import { NORECORD } from '../../constant/constant';
import ShowStatus from './ShowStatus';
import { IoEyeOutline } from 'react-icons/io5';
import { usePageNumber } from './PaginationQuery';

const inputHeader = ['action', 'checkbox'];

const TmMasterTable = (props) => {
  const { rows, columns, toggleModal, custom, handleDelete, buttonPermission, handleStatus, hidePagination } =
    props;
    console.log(props,"props data ");
    const [pageSize, setPageSize] = useState(hidePagination ? 100000 : 10);
  const [pagination, setPagination] = useState([]);
  const pageNumber = usePageNumber();
  let columnKey = [];
  let customKey = Array.isArray(custom)? [...custom] : [];
  if (rows.length > 0) {
    columnKey = columns.map((item) => item.field);
  }

useEffect(() => {
  handlePagination(pageNumber ? pageNumber : 1, rows, pageSize);
}, [rows, pageSize]);

  const handlePagination = (page, current = rows, size = pageSize) => {
  if (hidePagination) {
    setPagination(current);
    return;
  }
  const start = (page - 1) * size;
  const end = start + size;

  const data = current.slice(start, end);
  setPagination(data);
};



  const onShowSizeChange = (current, size) => {
  setPageSize(size);
  handlePagination(current, rows, size);
};
  return (
    <div className="icon-btn">
      <Table className="table-header-custom border" responsive>
        <thead>
          <tr>
            {columns.length > 0 &&
              columns.map((column, index) => (
                <th
                  className={`${
                    inputHeader.includes(column.field) ? 'text-center' : null
                  } ${column?.headerClassName || ''}`}
                  style={{ textAlign: column.align || 'left', verticalAlign: 'middle' }}
                  key={index + 1}
                >
                  {column.headerName}
                </th>
              ))}
            {(buttonPermission == undefined ||
              buttonPermission?.edit ||
              buttonPermission?.view ||
              buttonPermission?.delete) &&
              customKey.includes('action') && <th>ACTION</th>}
          </tr>
        </thead>
        <tbody>
          {pagination.length <= 0 && (
            <tr>
              <td colSpan={100} className="text-center">
                {NORECORD}
              </td>
            </tr>
          )}
          {pagination.length > 0 &&
            pagination?.map((row, idx) => (
              <tr key={idx + 1} className="hoverTr">
                {columnKey.map((item, index) => {
                  const col = columns[index];
                  return (
                  <td
                    key={index + 1}
                    className={col?.className || ''}
                    style={{ cursor: toggleModal ? 'pointer' : 'default', textAlign: col?.align || 'left', verticalAlign: 'middle', border: props.bordered ? '1px solid #dee2e6' : undefined }}
                    onClick={() => { if (toggleModal) toggleModal('View', row); }}
                  >
                    {col?.render ? (
                      col.render(row[item], row)
                    ) : item === 'status' || item === 'completion_status' || item === 'approval_status' ? (
                      <ShowStatus status={
                        item === 'status'
                          ? (row[item] ? 'Active' : 'InActive')
                          : String(row[item] || '')
                      } />
                    ) : (
                      <span title={row[item]}>{row[item] ?? '--'}</span>
                    )}
                  </td>
                  );
                })}
                {(buttonPermission == undefined ||
                  buttonPermission?.edit ||
                  buttonPermission?.view ||
                  buttonPermission?.delete) &&
                  customKey.includes('action') && (
                    <td>
                      <span>
                        {(buttonPermission == undefined ||
                          buttonPermission?.view) &&
                          (columns[1].field == 'department_name' ||
                          columns[1].field == 'designation_name'
                            ? true
                            : true) &&
                          (columns[1].field == 'title'
                            ? ![].includes(row.id)
                            : true) && (
                            <button
                              title="View"
                              className="btn p-0 m-0 icon-hover"
                              onClick={() => toggleModal('View', row)}
                            >
                              {<IoEyeOutline size={18} />}
                            </button>
                          )}
                      </span>
                      <span>
                        {' '}
                        {(buttonPermission == undefined ||
                          buttonPermission?.edit) &&
                          !row?.isTraineeRow &&
                          !row?.isTrainerRow &&
                          (columns[1].field == 'department_name' ||
                          columns[1].field == 'designation_name'
                            ? true
                            : true) &&
                          (columns[1].field == 'title'
                            ? ![].includes(row.id)
                            : true) && (
                            <button
                              title="Edit"
                              className="btn p-0 m-0 icon-hover"
                              onClick={() => toggleModal('Edit', row)}
                            >
                              {<FiEdit />}
                            </button>
                          )}
                      </span>

                      <span>
                        {(buttonPermission == undefined ||
                          buttonPermission?.delete) &&
                          !row?.isTraineeRow &&
                          !row?.isTrainerRow &&
                          (columns[1].field == 'department_name' ||
                          columns[1].field == 'designation_name'
                            ? row.id !== 1
                            : true) &&
                          (columns[1].field == 'title'
                            ? row?.departmentsID?.length !== 0 &&
                              row?.departmentsID
                            : true) && (
                            <button
                              className="btn p-0 m-0 icon-hover"
                              title="Delete"
                            >
                              <MdDeleteOutline
                                size={18}
                                onClick={() => handleDelete(row.id)}
                              />
                            </button>
                          )}
                      </span>
                      {handleStatus && (
                        <span style={{ marginLeft: -8 }}>
                          <button
                            className="btn p-0 m-0 icon-hover ms-2"
                            title={(row.status === 'Active' || row.status === 1 || row.status === true || String(row.status).toLowerCase() === 'active') ? "Deactivate" : "Activate"}
                            onClick={(e) => {
                               e.stopPropagation();
                               handleStatus(row);
                            }}
                          >
                            {(row.status === 'Active' || row.status === 1 || row.status === true || String(row.status).toLowerCase() === 'active') ? (
                               <MdDoNotDisturbOnTotalSilence size={20} />
                            ) : (
                               <TiPowerOutline size={18} />
                            )}
                          </button>
                        </span>
                      )}
                    </td>
                  )}
              </tr>
            ))}
        </tbody>
      </Table>
      {!hidePagination && (
        <div style={{ marginTop: '12px' }}>
          <TmPagination
            // defaultCurrent={pageNumber ? pageNumber : 1}
            onShowSizeChange={onShowSizeChange}
            total={rows.length}
            handlePagination={handlePagination}
          />
        </div>
      )}
    </div>
  );
};

export default TmMasterTable;